/* global globalThis */
import { extractRawBarcode } from './barcodeUtils';

export const createVariantId = () => `v_${globalThis.crypto?.randomUUID?.() || `${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`}`;
const hash = (value) => {
  let h = 2166136261;
  for (let i = 0; i < value.length; i += 1) h = Math.imul(h ^ value.charCodeAt(i), 16777619);
  return (h >>> 0).toString(36);
};

// Legacy IDs are deterministic until first write persists styleIds. Never use an array index as a saved list reference.
export const getProductVariants = (product = {}) => {
  const count = Math.max(product.styles?.length || 0, product.styleBarcodes?.length || 0, product.rawStyleBarcodes?.length || 0, product.styleDetails?.length || 0, product.styleIds?.length || 0);
  const seen = new Map();
  return Array.from({ length: count }, (_, index) => {
    const detail = product.styleDetails?.[index] || {};
    const name = String(product.styles?.[index] ?? '無樣式');
    const barcode = String(product.styleBarcodes?.[index] ?? '');
    const rawBarcode = String(product.rawStyleBarcodes?.[index] || extractRawBarcode(barcode, String(product.itemNumber ?? '')));
    const key = `${rawBarcode}\u0000${name}`;
    const occurrence = seen.get(key) || 0;
    seen.set(key, occurrence + 1);
    return { ...detail, id: product.styleIds?.[index] || detail.id || `legacy_${hash(key)}_${occurrence}`, index, name, barcode, rawBarcode, active: detail.active !== false };
  });
};

export const withStableVariants = (product = {}) => ({ ...product, styleIds: getProductVariants(product).map(v => v.id) });
export const selectedProductVariants = (product, ids = []) => getProductVariants(product).filter(v => ids.includes(v.id));
export const matchingVariantIds = (product, code) => {
  const term = String(code ?? '').trim();
  return getProductVariants(product).filter(v => v.active && term && (v.barcode === term || v.rawBarcode === term)).map(v => v.id);
};
export const mergeVariantSelection = (existing = [], incoming = []) => [...new Set([...existing, ...incoming])];
